import { render } from "./schedule-icon.vue?vue&type=template&id=257a1f57&scoped=true"
const script = {}

import "./schedule-icon.vue?vue&type=style&index=0&id=257a1f57&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257a1f57"]])

export default __exports__